import { Flex, Center, Text, Box } from '@chakra-ui/react';

interface InfoItemProps {
  icon: React.ReactNode;
  label: string;
  extra?: React.ReactNode;
  showBorder?: boolean;
  onClick?: () => void;
}

const InfoItem = ({ icon, label, extra, showBorder = true, onClick }: InfoItemProps) => {
  return (
    <Flex
      px="2"
      gap="2.5"
      justifyContent="space-between"
      backgroundColor="white"
      borderRadius="xl"
      cursor={onClick ? 'pointer' : 'initial'}
      onClick={onClick}
    >
      <Center fontSize="4xl">{icon}</Center>
      <Flex
        justifyContent="space-between"
        alignItems="center"
        fontSize="sm"
        flex="1"
        borderBottom={showBorder ? '1px solid' : ''}
        borderColor={showBorder ? 'border.subtle' : ''}
        fontWeight="medium"
        py="3"
      >
        <Text color="fg">{label}</Text>
        <Box overflow="hidden">{extra}</Box>
      </Flex>
    </Flex>
  );
};

const MemoizedInfoItem = memo(InfoItem);
export { MemoizedInfoItem as InfoItem };
